import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGoBack } from 'hooks/useGoBack';
import { EditProps } from 'react-admin';
import { IconButton } from 'shared/mui/IconButtons';
import { PageHeader } from 'shared/mui/PageHeader';
import { Stack } from 'shared/mui/Stack/Stack';
import { TypographyTitle } from 'shared/mui/Typography';

import { EditStyled, BoxStyled } from './EditPage.styled';

export type EditPageProps = {
  title: string;
  listName: string;
  children: React.ReactNode;
} & EditProps;

export const EditPage: React.FC<EditPageProps> = ({ title, listName, children, ...props }) => {
  const { goBack } = useGoBack();

  return (
    <BoxStyled>
      <PageHeader
        breadCrumbs={{
          currentPage: title,
          listName,
        }}
      />
      <EditStyled
        actions={false}
        render={() => (
          <>
            <Stack alignItems="center" direction="row" gap={1}>
              <IconButton onClick={goBack}>
                <ArrowBackIcon />
              </IconButton>
              <TypographyTitle fontWeight={500} lineHeight={1} size="small">
                {title}
              </TypographyTitle>
            </Stack>
            {children}
          </>
        )}
        {...props}
      />
    </BoxStyled>
  );
};
